const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 35,
    viewBox: "0 0 15.875 9.2604",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-263.26 -137.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70.714 -19.502)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.04,
    y: 159.69,
    width: 4.5806,
    height: 4.5806,
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.52917,
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.62,
    y: 159.69,
    width: 4.5806,
    height: 4.5806,
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.52917,
      stroke: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.2,
    y: 159.69,
    width: 4.5806,
    height: 4.5806,
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.52917,
      stroke: "currentColor"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquare);
export default __webpack_public_path__ + "static/media/icon_square.e41947bda953474948bfbd0d8e314de3.svg";
export { ForwardRef as ReactComponent };